<script lang="ts" setup>
  import TooltipWrapper from '@/common/shared/TooltipWrapper.vue';
  import CopyButton from '@/common/shared/CopyButton.vue';
  import useCopy from '@/common/composables/useCopy';

  const { copyText } = useCopy();

  const props = withDefaults(defineProps<
    {
      value: string | number,
      onlyIconClick?: boolean,
      alwaysShowIcon?: boolean
    }
  >(), {
    onlyIconClick: false,
    alwaysShowIcon: false
  });

  const copy = (event: MouseEvent) => {
    if (!props.onlyIconClick) {
      event.stopPropagation();
      copyText(props.value);
    }
  };

  defineExpose({
    copy
  });
</script>

<template>
  <div
    class="text-with-copy v-text-with-copy"
    :class="{ 'only-icon': onlyIconClick, 'always-show': alwaysShowIcon }"
    data-testid="text-with-copy"
    @click="copy"
  >
    <tooltip-wrapper
      :tooltip-text="value"
    >
      <slot>
        {{ value }}
      </slot>
    </tooltip-wrapper>
    <CopyButton
      class="copy-button"
      :text="value"
    >
    </CopyButton>
  </div>
</template>

<style lang="scss" scoped>
  .text-with-copy {
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    overflow: hidden;
    max-width: 100%;
    cursor: pointer;

    &.cell-with-icon {
      display: flex;
      flex-shrink: 1;
    }

    &.only-icon {
      cursor: default;
    }

    .copy-button {
      visibility: hidden;
    }

    &:hover,
    &.always-show {
      .copy-button {
        visibility: visible;
      }
    }
  }
</style>
